import get from "lodash/get";

function getConnDeviceStatus(state) {
  return get(state, "global.connection.deviceStatusOnline", false);
}

function getWsException(state) {
  return get(state, "global.connection.wsException", null);
}

export { getConnDeviceStatus, getWsException };
